(function(){

    const RESOURCES = document.querySelectorAll('.card-filter-wrapper .card');

    /*
     * Filter Click Handler
     */
    document.addEventListener('click', (evt) => {
        let selectedFilter = evt.target.dataset.filter || false;
        // delegate event
        if(!selectedFilter || !evt.target.classList.contains('nav-link')) return true;
        evt.preventDefault();

        document.querySelector('.card-filter .nav-link.active').classList.remove('active');
        evt.target.classList.add('active');

        if(selectedFilter){
            for(let i in RESOURCES){
                let resource = RESOURCES[i];
                if(resource.classList && resource.classList.contains('card')){
                    if(selectedFilter == 'all' || (resource.dataset.tag && resource.dataset.tag == selectedFilter)){
                        resource.classList.remove('d-none');
                        resource.classList.add('d-block');
                    } else {   
                        resource.classList.add('d-none');
                        resource.classList.remove('d-block');
                    }
                }
            }
        }

    });

    /*
    * "Load More" Click Handler
    */
    document.addEventListener('click', (evt) => {
        // delegate event
        if(!evt.target.classList.contains('js-load-more-resources-btn') && !evt.target.parentNode.classList.contains('js-load-more-resources-btn')) return true;
        evt.preventDefault();

        document.querySelector('.js-load-more-resources-btn').classList.add('d-none');
        for(let i in RESOURCES){
            let resource = RESOURCES[i];
            if(resource.classList){
                resource.classList.remove('hidden');
            }
        }

        console.log($.fn.unveil);
        
        $("img").trigger("unveil");
    });

    
}());